import {useEffect, useState} from 'react';

import {isEmpty} from 'lodash';

import {OAuthProviderCredentials} from '~/shared/store/storeModules/restrictedSharedActions';

import {FormValues} from '../types';
import {initialFormValues} from '../consts';

type UseUpdatedFormValuesArgs = {
  email?: string;
  fullName?: string;
} & OAuthProviderCredentials;

const useUpdatedFormValues = ({
  email,
  fullName,
  googleCode,
  facebookUserAccessToken,
  facebookUserId,
}: UseUpdatedFormValuesArgs) => {
  const [registerFormValues, setRegisterFormValues] = useState<FormValues>(initialFormValues);

  useEffect(() => {
    const valuesScheduledForUpdate: Partial<FormValues> = {};
    if (email && registerFormValues.email !== email) {
      valuesScheduledForUpdate.email = email;
    }
    if (fullName && registerFormValues.fullName !== fullName) {
      valuesScheduledForUpdate.fullName = fullName;
    }
    if (googleCode && registerFormValues.googleCode !== googleCode) {
      valuesScheduledForUpdate.googleCode = googleCode;
    }
    if (facebookUserAccessToken && registerFormValues.facebookUserAccessToken !== facebookUserAccessToken) {
      valuesScheduledForUpdate.facebookUserAccessToken = facebookUserAccessToken;
    }
    if (facebookUserId && registerFormValues.facebookUserId !== facebookUserId) {
      valuesScheduledForUpdate.facebookUserId = facebookUserId;
    }

    if (isEmpty(valuesScheduledForUpdate)) {
      return;
    }
    setRegisterFormValues(state => ({...state, ...valuesScheduledForUpdate}));
  }, [email, registerFormValues, fullName, googleCode, facebookUserAccessToken, facebookUserId]);

  return {registerFormValues, setRegisterFormValues};
};

export default useUpdatedFormValues;
